export class NyvaError extends Error {
  statusCode: number;
  nolog: boolean;
  apiError: string;
  apiErrorMessage?: string;

  constructor(
    message: string,
    statusCode: number,
    nolog: boolean,
    apiError: string,
    apiErrorMessage?: string,
  ) {
    super(message);
    this.statusCode = statusCode;
    this.nolog = nolog;
    this.apiError = apiError;
    this.apiErrorMessage = apiErrorMessage;
  }
}

export class EntrypointLoadError extends NyvaError {
  constructor(nyvaError: NyvaError) {
    super(
      nyvaError.message,
      nyvaError.statusCode,
      nyvaError.nolog,
      nyvaError.apiError,
      nyvaError.apiErrorMessage,
    );
  }
}
